import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { StagesValueType } from '~/models';
export const totalForValueType = (valueType, totalRate)=>valueType === StagesValueType.Amount ? totalRate : new Decimal(100);
export const computeFinalStageValue = (params)=>{
    const { stages, valueType, totalRate } = params;
    const total = totalForValueType(valueType, totalRate);
    const sumOfOthers = stages.slice(0, -1).reduce((acc, stage)=>acc.plus(stage.value), new Decimal(0));
    return total.minus(sumOfOthers).toDecimalPlaces(2);
};
export const withFinalStageComputed = (params)=>{
    const { stages, valueType, totalRate } = params;
    if (stages.length === 0) return stages;
    const total = totalForValueType(valueType, totalRate);
    const sumOfOthers = stages.slice(0, -1).reduce((acc, stage)=>acc.plus(stage.value), new Decimal(0));
    if (sumOfOthers.gt(total)) return stages;
    const lastValue = total.minus(sumOfOthers).toDecimalPlaces(2);
    const lastIndex = stages.length - 1;
    return stages.map((stage, index)=>index === lastIndex ? _object_spread_props(_object_spread({}, stage), {
            value: lastValue
        }) : stage);
};
